import { render, staticRenderFns } from "./Burger.vue?vue&type=template&id=eec64ba2&scoped=true&"
import script from "./Burger.vue?vue&type=script&lang=js&"
export * from "./Burger.vue?vue&type=script&lang=js&"
import style0 from "./Burger.vue?vue&type=style&index=0&id=eec64ba2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eec64ba2",
  null
  
)

export default component.exports